module.exports = __webpack_public_path__ + "static/media/IBM-GenAI(1).ea613bd7.jpg";